import { useContext, useEffect, useState } from 'react';

import { LanguageContext } from '../context/LanguageContext';
import { loadJson } from '../utils/loadJson'; 
// import languageData from '../i18n/translations.json';

const Languages = () => {
    const { language } = useContext(LanguageContext);
    const [translations, setTranslations] = useState({});
    const [programmingLanguages, setProgrammingLanguages] = useState([]);


      useEffect(() => {
        // Cargar cada JSON de forma independiente y asignarlo a su variable
        const fetchTranslations = async () => {
            const data = await loadJson(`${process.env.PUBLIC_URL}/json/translations.json`);
            setTranslations(data);
        };

        const fetchProgrammingLanguage = async () => {
            const data = await loadJson(`${process.env.PUBLIC_URL}/json/programmingLanguages.json`);
            setProgrammingLanguages(data);
        };

        fetchTranslations();
        fetchProgrammingLanguage();
    }, []);

    const t = translations[language] || {};
    return (
        <div className="wrapper">
            <p>
            <h2>{t.languages?.title}</h2>
            </p>
            <div className="cardContent">

                {programmingLanguages.map((lang) => (
                    <div className="cardLang">
                        <div className="card_head ">                             
                            <div className="langName"><b>{lang.name}</b></div>
                            
                        </div>
                        <div className="">
                        <img
                            src={lang.image}
                            alt={lang.altImage}
                            style={{
                                width: "100%",
                                // height: "70px",
                                borderRadius: "5px",
                                // marginBottom: "10px"
                            }}
                        />
                        </div>
                        <div className="card_head ">
                             <div className="detailLangName">{lang.level}</div>
                         </div>

                    </div>
                ))}
            </div>
        </div>
    );
};

export default Languages;